import PropTypes from 'prop-types';
import styles from './FJMobileDefaultPreview.module.less';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import UploadIcon from '../../../assets/svg/mobile-upload.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';

const FJMobileDefaultPreview = props => {
    const { title, description, uploadText = 'upload-image', uploadImg, videoSrc = [] } = props;

    return (
        <div className={styles.container}>
            <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: FJLocalStore._(title) }} />
            <div className={styles.description}>{FJLocalStore._(description)}</div>
            <video className={styles.video} src={videoSrc} autoPlay muted loop preload='auto' playsInline />
            <FJFileUpload onUpload={uploadImg}>
                <FJIconButton
                    className={styles.btn}
                    icon={<UploadIcon />}
                    type={'gradient'}
                    text={FJLocalStore._(uploadText)}
                    textClassName={styles.btn_text}
                />
            </FJFileUpload>
        </div>
    );
};
FJMobileDefaultPreview.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    uploadText: PropTypes.string,
    uploadImg: PropTypes.func,
    videoSrc: PropTypes.string,
};
export default FJMobileDefaultPreview;
